'use strict';

class MathUtil {
  subtract(baseNumber, subtractNumber, decimalDigitNum = 4) {
    const multiple = Math.pow(10, decimalDigitNum);
    const base = this.getInteger(baseNumber, decimalDigitNum);
    const sub = this.getInteger(subtractNumber, decimalDigitNum);

    return (base - sub) / multiple;
  }

  add(baseNumber, addNumber, decimalDigitNum = 4) {
    const multiple = Math.pow(10, decimalDigitNum);
    const base = this.getInteger(baseNumber, decimalDigitNum);
    const add = this.getInteger(addNumber, decimalDigitNum);

    return (base + add) / multiple;
  }

  getIntDigit(value) {
    return String(Math.floor(value)).length;
  }

  getInteger(num, decimalDigitNum) {
    const strValues = String(num).split('.');
    let addDigit = strValues[1] || '';

    if (addDigit.length > decimalDigitNum) {
      addDigit = addDigit.slice(0, decimalDigitNum);
    }

    const length = decimalDigitNum - addDigit.length;
    for (let i = 0; i < length; i++) {
      addDigit += '0';
    }

    return parseInt(strValues[0] + addDigit)
  }
}

export default angular.module('leptonApp.MathUtil', [])
  .service('MathUtil', [MathUtil])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/math_util/math_util.js